'use client'
import { compactClassName } from '@/components/homepage-october/compact'
import * as React from 'react'

/** Calendar context is separate from the provenance of a price snapshot. */
export function localCalendarDate(date: Date) {
  return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
}
export function DailyDate({ source }: { source: string }) {
  const [today, setToday] = React.useState('')
  React.useEffect(() => {
    let timer: ReturnType<typeof setTimeout>
    const refresh = () => {
      clearTimeout(timer)
      const now = new Date()
      setToday(localCalendarDate(now))
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
      timer = setTimeout(refresh, midnight.getTime() - now.getTime() + 100)
    }
    refresh()
    document.addEventListener('visibilitychange', refresh)
    window.addEventListener('focus', refresh)
    return () => { clearTimeout(timer); document.removeEventListener('visibilitychange', refresh); window.removeEventListener('focus', refresh) }
  }, [])
  return <span className={compactClassName("v3-daily-date")}><span data-calendar-date>{today ? `Today · ${today}` : 'Price comparison'}</span><span className={compactClassName("v3-source-date")}>Source snapshot · {source.replace(/^Checked\s*/i, '')}</span></span>
}
